import BaseProfilePage from "@/components/profile/BaseProfilePage"
import { PROFILE_ROLE_CONFIG } from "@/constants/profileRoleConfig"

const AdminProfile = () => {
    return <BaseProfilePage config={PROFILE_ROLE_CONFIG.admin} />
}

export default AdminProfile
